import axios from 'axios';
import AppConfig from "../../../AppConfig";

let URL = AppConfig.HOST_API();

export default {

    wyslijFcmDoWszystkichKierowcow(data) {
        return axios({
            method: 'post',
            url: URL+'fcm/kierowcy',
            data: JSON.stringify(data),
        })
    },

    wyslijFcmDoDanychKierowcow(data) {
        return axios({
            method: 'post',
            url: URL+'fcm/tokens',
            data: JSON.stringify(data),
        })
    },

    pobierzPowiadomieniaOdKierowcow(obj){
        return axios({
            method: 'get',
            url: URL+'fcm/historia/kierowcy/szukaj?dataOd='+obj.dataOd+'&dataDo='+obj.dataDo,
        })
    },

    wyslijEmailNaTestowyAdres(data,email){
        return axios({
            method: 'post',
            url: URL+'mail/powiadomienie/test?email='+email,
            data: JSON.stringify(data),
        })
    },

    wyslijEmailDoKlientowNaKurs(data){
        return axios({
            method: 'post',
            url: URL+'mail/powiadomienie/kurs',
            data: JSON.stringify(data),
        })
    },

    pobierzListeKlientowDoPowiadomieniaNaDanyKurs(idKu){
        return axios({
            method: 'get',
            url: URL+'klienci/mail/kurs/'+idKu,
        })
    },

    wyslijEmailaDoKlienta(data){
        return axios({
            method: 'post',
            url: URL+'mail/powiadomienie/klient',
            data: JSON.stringify(data),
        })
    },

}


// WEBPACK FOOTER //
// ./src/modules/komunikaty/powiadomienia/PowiadomieniaService.js